import React, { useId, useState } from 'react';
import PropTypes from "prop-types";
import { ReactComponent as DownloadIcon } from '../utilities/icons/download.svg';
import './RecordDownloadLinks.css';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Dialog from '../dialog/Dialog';

const DownloadLink = ({ to, width, height, size, bitrate}) => {
  const resolution = `${width}x${height}`;
  const sizeMB = `${Math.ceil(size / 2**20)} MB`;
  const bitrateKbps = `${Math.ceil(bitrate / 2**10)} kbps`;
  const { t } = useTranslation();
  return (
    <Button variant="link" className="record-download-link-button mb-3" href={to} aria-label={`${t('record_download_link_aria_label')} ${resolution} - ${bitrateKbps} - ${sizeMB}`}>
        <DownloadIcon aria-hidden={true} />
        {resolution} - {bitrateKbps} - {sizeMB}
    </Button>
  );
};

const RecordDownloadLinksContent = ({ downloadableMedia }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Row className="mb-3">
        <Col>
            {t('record_download_links_help_content')}
        </Col>
      </Row>
      <Row>
        <Col>
          <ol className="record-download-link-list">
            {Object.values(downloadableMedia).map((media, i) => (
              <li key={media.url || i}>
                <DownloadLink 
                  i={i}
                  to={`${process.env.REACT_APP_LATAAMO_PROXY_SERVER}/api/download/${media.url}`} 
                  width={media.width} 
                  height={media.height} 
                  size={media.size} 
                  bitrate={media.bitrate}
                />
              </li>
            ))}
          </ol>
        </Col>
      </Row>
    </Container>
  );
};

const RecordDownloadLinks = ({ downloadableMedia, title }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const headerId = useId();

  const hideDialog = () => setShow(false);
  const toggle = () => setShow(!show);

  const showButton = (
    <Button
        size="sm"
        onClick={toggle}
        variant="primary"
        aria-label={t('record_download_link_aria_label')}
        aria-haspopup="dialog"
        className="record-download-button"
    >
      <DownloadIcon aria-hidden="true"/>
        <span> {t('record_download_button_text')} </span>
    </Button>
  );

  return (
    <Dialog showComponent={showButton} show={show} hide={hideDialog} aria-labelledby={headerId}>
      <Modal.Header id={headerId} closeButton closeLabel={t('help_dialog_close_label')} className="record-download-links-header">
        {t('record_download_links_header')} "{title}"
      </Modal.Header>
      <Modal.Body className="record-download-links-body">
        <RecordDownloadLinksContent downloadableMedia={downloadableMedia} />
      </Modal.Body>
    </Dialog>
  );
};

RecordDownloadLinks.propTypes = {
  downloadableMedia: PropTypes.object
};

export default RecordDownloadLinks;
